import { useTheme } from '@mui/material'

interface ISuccessIconProps {
  className?: string
}

const SuccessIcon = ({ className }: ISuccessIconProps) => {
  const theme = useTheme()

  return (
    <svg
      width="10"
      height="10"
      className={className}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5C10 7.76142 7.76142 10 5 10Z"
        fill={theme.palette.custom.primary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.41259 5.5875L6.81845 3.18164L7.46127 3.82446L4.41259 6.87315L2.72754 5.1881L3.37036 4.54528L4.41259 5.5875Z"
        fill="white"
      />
    </svg>
  )
}

export default SuccessIcon
